import Account from "@/helper/AccountHelper.js";

export function UserFlag() {
    this.userFlag = Account.getUserFlag();

    this.isFlag64 = function () {
        for (let i of this.userFlag) {
            if (i == 'flag64') {
                return true;
            }
        }
        return false;
    };

    this.isFlag1 = function () {
        for (let i of this.userFlag) {
            if (i == 'flag1') {
                return true;
            }
        }
        return false;
    };
}
